package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_03_29_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who had just defeated several Slaad and met Korvis Whisperclaw. Korvis and his raven examine the corpses of the Slaad. Korvis explains that he likes to collect “memories of battle.” The raven gives Korvis what appears to be a Lizardfolk tooth. Korvis introduces the heroes to his raven named Mimi and explains to Bigglesworth that Mimi is “not for eating.”")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Korvis Facts:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("He has traveled to this side of the Greatmarsh before, but he is more familiar with the eastern side of the marsh.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("He has seen a green and black dragon in the past from a great distance but never faced a dragon in battle.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("He worships Ellewen, Lady of Luck, Mistress of the Wild, but he seems to place more faith in a more general concept of “the circle of life.”")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Zolnur Zizzdek of the Roving Peers arranged for Korvis to guide the guardians through the Greatmarsh, but Korvis is unaware of the heroes’ greater mission. Bigglesworth and Tuesday explain the Shard of Concar and the general location of the nearby underwater shard. Korvis has noticed more monsters in the material plane recently, so he seems keen to aid the heroes.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Korvis helps the heroes find a good camping spot. He is amazed at Dirk’s Tiny Hut spell. He joins Annette in night watch shift #3.")
    }
}
